import { createApp } from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";

import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
// import MockAdapter from "@/core/mock/MockService";
//import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import "bootstrap";
import Vidle from 'v-idle-3'

import OidcService from "@/core/services/OidcService";
import { isOidcConfigured } from "@/core/config/OidcConfig";

// Handle OIDC callback before mounting the app
const path = window.location.pathname;

if (path === "/oidc/callback" && isOidcConfigured()) {
  OidcService.init();
  OidcService.signinRedirectCallback()
    .then((oidcUser) => {
      const state = oidcUser.state as { codeArk?: string; returnPath?: string } | undefined;
      const codeArk = state?.codeArk;
      if (codeArk) {
        window.localStorage.setItem("codeArk", codeArk);
      }
      const returnPath = state?.returnPath || "/board";
      window.location.replace(window.location.origin + "/#" + returnPath);
    })
    .catch((err) => {
      console.error("OIDC callback error:", err);
      window.location.replace(window.location.origin + "/#/sign-in");
    });
} else {
  // Normal app bootstrap
  OidcService.init();

  const app = createApp(App);

  app.use(store);
  app.use(router);
  app.use(ElementPlus);
  app.use(Vidle as any);

  //ApiService.init(app);
  //MockAdapter.init(app);
  initApexCharts(app);
  initInlineSvg(app);
  initVeeValidate();

  app.use(i18n);

  app.mount("#app");
}
